// formUi/PrefBundlerBtn.js
export class PrefBundlerBtn {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;
    this.id = this.node.dataset.id;

    // pref 用の値を data 属性から読む
    this.params = {
      pref1: Number(this.node.dataset.pref1 ?? 0),
      pref2: Number(this.node.dataset.pref2 ?? 0),
      pref3: Number(this.node.dataset.pref3 ?? 0),
      pref4: Number(this.node.dataset.pref4 ?? 0),
      pref5: Number(this.node.dataset.pref5 ?? 0),
      special: this.node.dataset.special ?? undefined,
    };

    // ★ 王道などで使う taste4 用
    this.tasteParams = {};
    if (this.node.dataset.taste4 !== undefined) {
      this.tasteParams.taste4 = Number(this.node.dataset.taste4);
    }

    // is-selected 用クラス名（Aic 側の config に合わせる）
    this.activeClassName = this.store.config.designActiveClassName;

    this.node.addEventListener('click', () => this.handleClick());
  }

  handleClick() {
    // どの pref ボタンがアクティブか
    this.app.setState('activePrefBundlerBtnId', this.id);

    // pref の状態を更新
    this.app.setState('pref', this.params);

    // ★ taste4 も一緒に更新する
    const currentTaste = this.app.getState('taste') || {};

    if (this.tasteParams.taste4 !== undefined) {
      // 王道など data-taste4 を持つボタン：
      // → taste4 にその値をセット（例: 2）
      this.app.setState('taste', {
        ...currentTaste,
        ...this.tasteParams,
      });
    } else {
      // それ以外のボタン：
      // → taste4 を 0 に戻す
      this.app.setState('taste', {
        ...currentTaste,
        taste4: 0,
      });
    }

    // 出発時刻セレクトの disable/enable
    this.toggleStartTimeSelect();
  }

  toggleStartTimeSelect() {
    // Aic の selector 設定をそのまま利用
    const startTimeSelect = document.querySelector(
      this.store.config.selector.startTimeSelect
    );
    if (!startTimeSelect) return;

    const btnIdNum = this.id.replace(/[^0-9]/g, '');

    // 「特別な旅」が id=6 という前提
    if (btnIdNum === '6') {
      startTimeSelect.disabled = true;
    } else {
      startTimeSelect.disabled = false;
    }
  }

  active() {
    this.node.classList.add(this.activeClassName);
  }

  inactive() {
    this.node.classList.remove(this.activeClassName);
  }

  render() {
    const activeId = this.app.getState('activePrefBundlerBtnId');
    if (activeId === this.id) {
      this.active();
      // 初期描画時にも状態を合わせておきたいならここでも呼ぶ
      this.toggleStartTimeSelect();
    } else {
      this.inactive();
    }
  }
}
